import { sendAuthenticatedRequest } from "./functions";
import {
  StoredPromotionCode,
  clearStoredPromotionCode,
  getStoredPromotionCode,
  storePromotionCode,
} from "./localStorage";

export const validatePromotionCode = async (
  code: string,
): Promise<StoredPromotionCode> => {
  const response = await sendAuthenticatedRequest(
    `${process.env.REACT_APP_BF_API_BASE_URL}/promotions/validate`,
    {
      method: "POST",
      jsonBody: {
        code,
      },
    },
  );
  const responseData = await response.json();

  return {
    promotionCode: responseData.promotionCode,
    confirmationMessage: responseData.confirmationMessage || undefined,
  };
};

export { clearStoredPromotionCode, getStoredPromotionCode, storePromotionCode };

export type { StoredPromotionCode };
